import * as React from "react";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./msalInstance";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ApolloProvider } from "@apollo/client";
import { getApolloClient } from "./services/apolloClient";

const wrapper = ({ element }) => (
  <ApolloProvider client={getApolloClient(false)}>
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>{element}</MsalProvider>
    </Provider>
  </ApolloProvider>
);

export default wrapper;
